import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';

@Component({
  standalone: true,
  selector: 'mode-report-clone-progress',
  imports: [SharedUtilToastModule],
  templateUrl: './report-clone-progress.component.html',
  styleUrls: ['./report-clone-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ReportCloneProgressComponent extends Toast {}
